<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Заполните данные о&nbsp;заявке</h3>
      <TextInput :required="true" @setError="errors['request-number'] = $event" v-model="form.request_number" text="Номер заявки" :validation="requestNumberValidation" name="request-number" />
      <TextInput :required="true" @setError="errors['applicant-name'] = $event" v-model="form.applicant.name" @update:modelValue="suggestName($event)" text="ФИО Заявителя" name="applicant-name" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="form.applicant.name.split(' ').filter(el => el.trim()).length >= 3" />
      <NumberInput :required="true" mask="+7 (###) ###-##-##" @setError="errors.tel = $event" :filled="(v) => v.length == 18" v-model="form.applicant.tel" text="Номер мобильного телефона" name="applicant-tel" />

      <!--      <template v-if="this.form.event.risktype == 'Жизнь/Здоровье'">
              <p class="step__text">Заполненный бланк Заявления (от каждого Выгодоприобретателя, если данное заявление не содержит всей информации)</p>
              <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(0, $event)" name="files-blank[]" v-model="form.files.blank" />
              <p class="step__text">Паспорт (основной разворот и страница с пропиской)</p>
              <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(1, $event)" name="files-passport[]" v-model="form.files.passport" />
            </template>
            <template v-if="dynamicFields.vipiska">
              <p class="step__text">Выписка из амбулаторной карты / Извещение о больном Ф090/У (для онкозаболеваний) / Выписка из Канцер-регистра (для онкозаболеваний)</p>
              <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(2, $event)" name="files-vipiska[]" v-model="form.files.vipiska" />
            </template>
            <template v-for="el, index in dynamicFields.adds" :key="el.name + '~' + index">
              <p class="step__text">{{ el.text }}</p>
              <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(100 + index, $event)" :name="el.name + '[]'" v-model="form.files[el.name]" />
            </template>
            <h4 v-if="dynamicFields.unadds.length > 0" class="step__title step__title_left">Дополнительные документы по риску Хищение деталей автомобиля (необязательно):</h4> 
            <template v-for="el, index in dynamicFields.unadds" :key="el.name + '~' + index">
              <p class="step__text">{{ el.text }}</p>
              <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(400 + index, $event)" :name="el.name + '[]'" v-model="form.files[el.name]" />
            </template>-->

      <!--      <h4 v-if="dynamicFields.criminalCase" class="step__title step__title_left">В случае ДТП или в результате получения телесных повреждений (НС):</h4>-->
      <!--      <p v-if="dynamicFields.criminalCase" class="step__text">Постановление о возбуждении/ отказе в возбуждении уголовного дела</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(3, $event)" v-if="dynamicFields.criminalCase" name="files-criminalCase[]" v-model="form.files.criminalCase" />
      <h4 v-if="dynamicFields.death" class="step__title step__title_left">В случае смерти:</h4>
      <p v-if="dynamicFields.death" class="step__text">Справка о смерти/ Медицинское свидетельство о смерти</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(4, $event)" v-if="dynamicFields.death" name="files-deathproof[]" v-model="form.files.deathproof" />
      <p v-if="dynamicFields.death" class="step__text">Свидетельство о праве на наследство по закону или справка о круге наследников</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(5, $event)" v-if="dynamicFields.death" name="files-legacyproof[]" v-model="form.files.legacyproof" />
      <p v-if="dynamicFields.death" class="step__text">Акт судебно-медицинского исследования трупа</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(6, $event)" v-if="dynamicFields.death" name="files-bodyresearchproof[]" v-model="form.files.bodyresearchproof" />
      <p v-if="dynamicFields.death" class="step__text">Акт протоколов вскрытия</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(7, $event)" v-if="dynamicFields.death" name="files-bodyautopsyproof[]" v-model="form.files.bodyautopsyproof" />
      <h4 v-if="dynamicFields.invalid" class="step__title step__title_left">В случае получения инвалидности:</h4>
      <p v-if="dynamicFields.invalid" class="step__text">Справка об установлении группы инвалидности</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(8, $event)" v-if="dynamicFields.invalid" name="files-invalidproof[]" v-model="form.files.invalidproof" />
      <p v-if="dynamicFields.invalid" class="step__text">Протокол медико-социальной экспертизы</p>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(9, $event)" v-if="dynamicFields.invalid" name="files-medprotocol[]" v-model="form.files.medprotocol" />
      <template v-for="beneficiary_index in dynamicFields.FATCA" :key="beneficiary_index">
        <h4 class="step__title step__title_left">Документы FATCA <span class="step__sm">({{ form.beneficiaries[beneficiary_index].name }})</span></h4>
        <p class="step__text">Копия свидетельства, подтверждающего отказ от гражданства США</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(997 * (beneficiary_index + 1), $event)" :name="`files-b${beneficiary_index}-FATCA1[]`" v-model="form.files[`b${beneficiary_index}-FATCA1`]" />
        <p class="step__text">Копия отказа от статуса постоянного жителя США</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(998 * (beneficiary_index + 1), $event)" :name="`files-b${beneficiary_index}-FATCA2[]`" v-model="form.files[`b${beneficiary_index}-FATCA2`]" />
        <p class="step__text">Иной документ основание/заявление, подтверждающие отсутствие гражданства США</p>
        <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(999 * (beneficiary_index + 1), $event)" :name="`files-b${beneficiary_index}-FATCA3[]`" v-model="form.files[`b${beneficiary_index}-FATCA3`]" />
      </template>-->
      <h4 class="step__title step__title_left">Дополнительные документы</h4>
      <p class="step__text">Прикрепить дополнительные документы</p>
      <p class="step__text">Документы могут быть в формате pdf, jpg, png, tiff, каждый не больше 10 мб.</p>
      <br>
      <FileInput :forbiddenFileExts="forbiddenFileExts" @fileExtsChange="setFileExts(0, $event)" name="files-additinal[]" v-model="form.files.additinal" />
      <div class="step__buttonflex">
        <Btn class="step__next step__next_special" @click.stop.prevent="$store.commit('setAdForm', false)">Назад</Btn>
        <Btn class="step__next step__next_special" :disabled="!filled" @click.stop.prevent="CheckExtsAndGoNext">Далее</Btn>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import FileInput from '../inputs/FileInput.vue';
import TextInput from '../inputs/TextInput.vue';
import NumberInput from "../inputs/NumberInput.vue";
import { mapState } from 'vuex';
import nameSuggest from '@/mixins/nameSuggest';
import CyrillicToTranslit from 'cyrillic-to-translit-js';

export default {
  components: { FileInput, Btn, TextInput, NumberInput },
  mixins: [nameSuggest],
  data: () => ({
    errors: {},
    fileExts: [],
    forbiddenFileExts: [],
    refreshKey: 0,
    cyrillicToTranslit: new CyrillicToTranslit()
  }),
  props: {
    active: { type: Boolean }
  },
  beforeMount() {
    const savedNumber = localStorage.getItem('application_number')
    if (savedNumber)
      this.form.request_number = savedNumber
  },
  methods: {
    setFileExts(index, array) {
      this.fileExts[index] = array
      this.refreshKey++
    },
    async CheckExtsAndGoNext() {
      try {
        let exts = Array.from(this.fileExts.flat())
        let res = await this.$store.dispatch('ad_storage/sendExts', exts.map(el => el.toLowerCase()), this.form.request_number)
        if (res === false) {
          return this.$store.dispatch('ad_storage/showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            action: this.CheckExtsAndGoNext
          })
        }
        let forbidden = []
        for (let i = 0; i < res.length; i++)
          if (res[i])
            forbidden.push(exts[i])
        forbidden = Array.from(new Set(forbidden))
        this.forbiddenFileExts = forbidden
        if (this.forbiddenFileExts.length)
          return
      } catch (err) {
        console.error(err)
        return this.$store.dispatch('ad_storage/showErrorPopup', {
          title: 'Ошибка!',
          text: 'Попробуйте повторить запрос',
          button: 'Повторить',
          action: this.CheckExtsAndGoNext
        })
      }
      this.$store.commit('ad_storage/nextStep')
    },
    requestNumberValidation(val) {
      if (val.length > 50) return 'Не более 50 символов'
    }
  },
  computed: {
    ...mapState('ad_storage', ['form']),
    // dynamicFields() {
    //   let obj = {
    //     criminalCase: false,
    //     death: false,
    //     invalid: false,
    //     vipiska: false,
    //     FATCA: [],
    //   }
    //   if (this.form.event.risktype == "Жизнь/Здоровье") {
    //     if (this.form.event.reason == 'Несчастный случай')
    //       obj.criminalCase = true
    //     if (this.form.event.type == 'Смерть') {
    //       obj.death = true
    //       obj.vipiska = true  
    //     }
    //     if (this.form.event.type.toLowerCase().match(/^инвалидность/)) {
    //       obj.invalid = true
    //       obj.vipiska = true  
    //     }
    //   }
    //
    //   let adds = []
    //   let unadds = []
    //
    //   const pstext = 'Паспорт получателя страхового возмещения' + (this.form.event.risktype == 'Жизнь/Здоровье'?', если отличается от основного':'')
    //
    //   switch (this.form.event.reason) {
    //     case "Травма":
    //       adds.push(
    //         pstext,
    //         'Рентгеновские снимки и/или их описание с заключением врача-рентгенолога по травме',
    //       )
    //       break
    //   }
    //   switch (this.form.event.type) {
    //     case "Купон":
    //     case "Дожитие":
    //       adds.push(
    //         pstext,
    //         'Селфи с паспортом',
    //         'Декларация налогового резиденства',
    //       )
    //       for (let i = 0; i < this.form.beneficiaries.length; i++)
    //         if (this.form.beneficiaries[i].FATCA.renunciation == 'Да')
    //           obj.FATCA.push(i)
    //       break
    //     case "Критическое заболевание":
    //       adds.push(
    //         pstext,
    //         'Направление лечащего Врача на плановое стационарное лечение',
    //         'Результаты проведенных анализов и исследований, на основании которых был поставлен диагноз и назначено лечение',
    //       )
    //       break  
    //     case "Временная нетрудоспособность":
    //       adds.push(
    //         pstext,
    //         'Все листки нетрудоспособности, оформленные и принятые на оплату органом/ учреждением/организацией, который располагает оригиналами предоставленных листков нетрудоспособности (электронный лист нетрудоспособности /копия, заверенная работодателем)',
    //         'Справка 2-НДФЛ, содержащая информацию о размере заработной платы, в том числе за 3 месяца, предшествовавших временной утрате трудоспособности',
    //       )
    //       break
    //
    //     case "Залив":
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Акт обследования технического состояния объекта с указанием даты, причины и виновника залива с печатью, выдавшего учреждения',
    //       )
    //       break
    //     case "Пожар":
    //       obj.criminalCase = true
    //
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Акт о пожаре МЧС России или донесение о пожаре',
    //         'Результаты пожарно-технической экспертизы',
    //         // 'Постановление о возбуждении уголовного дела или постановление об отказе в возбуждении уголовного дела',
    //       )
    //       break
    //     case "Взрыв":
    //       obj.criminalCase = true
    //
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Акт или справка из МЧС России',
    //         // 'Постановление о возбуждении уголовного дела или постановление об отказе в возбуждении уголовного дела',
    //       )
    //       break
    //     case "Стихийное бедствие":
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Справка Федеральной службы РФ по гидрометеорологии и мониторингу окружающей среды или справка МЧС России',
    //       )
    //       break
    //     case "Удар молнии":
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Справка Федеральной службы РФ по гидрометеорологии и мониторингу окружающей среды или справка МЧС России',
    //       )
    //       break
    //     case "Механические повреждения":
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Справка ГИБДД, ДЕЗ, ЖЭУ, сельской администрации, полиции, лесничества, МЧС, Межгосударственного авиационного комитета (МАК) и т.д',
    //       )
    //       break
    //     case "Противоправные действия":
    //       obj.criminalCase = true
    //
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         // 'Постановление о возбуждении уголовного дела или постановление об отказе в возбуждении уголовного дела',
    //         'Чеки, счета, квитанции, акты на украденное имущество',
    //       )
    //       break
    //     case "Повреждение имущества соседей":
    //       adds.push(
    //         pstext,
    //         'Выписка из ЕГРН',
    //         'Документы, выданные компетентными органами или организациями в связи с произошедшим событием, подтверждающие наступление события, имеющего признаки страхового случая, с указанием причины, даты и времени его возникновения и описанием причиненного ущерба',
    //       )
    //       break
    //     case "Титул (утрата собственности)":
    //       adds.push(
    //         'Копия документа, удостоверяющего личность Заявителя и Выгодоприобретателя',
    //         'Исковое заявление, решение суда, определение об отмене ареста на застрахованное имущество (если таковой был наложен ранее)',
    //       )
    //       break
    //     case "Досрочное прекращение аренды":
    //       adds.push(
    //         pstext,
    //         'Смс/@/письма, подтверждающие досрочное прекращение договора аренды',
    //         'Подтверждение оплаты аренды',
    //         'Договор аренды',
    //         'Счета, квитанции, иные платежные док-ты, подтверждающие размер расходов на проживание/перевозку вещей (при возникновении таких расходов)',
    //       )
    //       break
    //     case "Потеря работы/Снижение ЗП":
    //       adds.push(
    //         pstext,
    //         'Письменное уведомление работодателя об увольнении с указанием его причин',
    //         'Приказ об увольнении',
    //         'Соглашение о расторжении трудового договора',
    //         'Трудовая книжка (все страницы) с отметкой об увольнении, заверенная нотариально или бывшим работодателем',
    //         'Трудовой договор с места работы со всеми дополнениями',
    //         'Справка 2-НДФЛ',
    //         'Справка из «Центр занятости населения»',
    //       )
    //       break
    //     case "Полная гибель":
    //       adds.push(
    //         pstext,
    //         'Водительское удостоверения водителя',
    //         'ПТС, свидетельство о регистрации ТС',
    //         'Справка о ДТП',
    //         'Отчет об оценке независимого оценщика, содержащий вывод о том, что восстановление транспортного средства экономически нецелесообразно',
    //         'Страховой акт с указанием размера выплаты по договору добровольного страхования средств автотранспорта',
    //         'Отчет об оценке независимого оценщика, содержащий расчет стоимости годных остатков ТС, или иной документ Страховщика КАСКО, содержащий данную информацию (если транспортное средство было застраховано по договору добровольного страхования автотранспортного средства)',
    //       )
    //       break
    //     case "Хищение деталей автомобиля":
    //       adds.push(
    //         pstext,
    //         'ПТС, свидетельства о регистрации ТС',
    //         'Постановление ОВД',
    //         'Страховой акт с указанием размера выплаты по договору добровольного страхования средств автотранспорта',
    //       )
    //       break
    //     case "Поломка":
    //       adds.push(
    //         pstext,
    //         'ПТС, свидетельства о регистрации ТС (СТС)',
    //         'Фотографии места происшествия',
    //         'Фотография одометра',
    //         'Чеки, подтверждающие оплату услуг по ремонту или замене',
    //         'Заказ-наряд СТО',
    //       )
    //       break
    //     case "Повреждения шин или дисков":
    //       adds.push(
    //         pstext,
    //         'ПТС, свидетельства о регистрации ТС (СТС)',
    //         'Фотографии места происшествия',
    //         'Фотографии поврежденного колеса или колес, шин',
    //         'Фотография одометра',
    //         'Фотографии отремонтированных колеса или колес, шин',
    //         'Чеки, подтверждающие оплату услуг по ремонту или замене',
    //       )
    //       //Дополнительно по риску Хищение шин или дисков: (ДОПОЛНИТЕЛЬНЫЕ ДОКУМЕНТЫ - НЕОБЯЗАТЕЛЬНЫЕ)
    //       unadds.push(
    //         'Копия постановления о возбуждении уголовного дела',
    //         'Копия документов о приобретении похищенных шин и дисков, в тч. при приобретении вместе с ТЗ спецификация, подтверждающая наличие указанных шин и дисков на ТС',
    //         'Копия чека/договора на приобретение новых шин и дисков в замен украденных (похищенных) с подтверждение факта оплаты',
    //       )
    //       break
    //     case "Утрата банковской карты":
    //       adds.push(
    //         pstext,
    //         'Выписка по текущему счету, подтверждающая факт проведения несанкционированных транзакций',
    //         'Банковская выписка со счета, подтверждающая факт списания банковской комиссии за перевыпуск Карты',
    //         'Результат опротестования операций',
    //       )
    //       break
    //     case "Утрата денежных средств":
    //       adds.push(
    //         pstext,
    //         'Выписка по текущему счету, подтверждающая факт проведения несанкционированных транзакций',
    //         'Постановление о возбуждении / об отказе в возбуждении уголовного дела с указанием даты, обстоятельств события и причиненного ущерба',
    //         'Отчет уполномоченного структурного подразделения Банка эмитента о заявленных несанкционированных транзакциях с указанием даты, времени, суммы каждой опротестовываемой операции, текущем статусе рассмотрения обращения Владельца счета',
    //       )
    //       break
    //     case "Утеря ключей/документов/имущества":
    //       adds.push(
    //         pstext,
    //         'Фискальный чек или товарный чек (накладная) на оплату расходов по изготовлению ключей и запирающих устройств от жилого помещения и или автомобиля) и/или покупке мобильного телефона, содержащие сведения о факте покупки, сумме и назначении платежа',
    //         'Квитанция по оплате гос. пошлины на восстановление личных документов, содержащие сведения сумме и назначении платежа',
    //         'Постановление о возбуждении / об отказе в возбуждении уголовного дела с указанием даты, обстоятельств события и причиненного ущерба',
    //       )
    //       break
    //     case "Поломка имущества":
    //       adds.push(
    //         pstext,
    //         'Фото поломки',
    //         'Документ, подтверждающих техническую неисправность',
    //       )
    //       break
    //     case "Повреждение имущества при доставке":
    //       adds.push(
    //         pstext,
    //         'Акт о поломке',
    //         'Фото поломки',
    //       )
    //       break
    //   }
    //
    //   // Исключаем дубли элементов
    //   adds = Array.from(new Set(adds));
    //   unadds = Array.from(new Set(unadds));
    //
    //   obj.adds = adds.map(el => ({
    //     text: el,
    //     name: 'files-' + this.cyrillicToTranslit.transform(el, '_').toLowerCase().split('_').slice(0, 5).join('_').replace(/[^a-z0-9_]/g, '_').replace(/^_+|_+$/g, '').replace(/_{2,}/g, '_')
    //   }))
    //   obj.unadds = unadds.map(el => ({
    //     text: el,
    //     name: 'files-' + this.cyrillicToTranslit.transform(el, '_').toLowerCase().split('_').slice(0, 5).join('_').replace(/[^a-z0-9_]/g, '_').replace(/^_+|_+$/g, '').replace(/_{2,}/g, '_')
    //   }))
    //   return obj
    // },
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      
      if (!this.form.request_number) return false
      
      if (!this.form.applicant.name) return false
      
      if (!this.form.files.additinal.length) return false
      
      // let required = [] //'blank', 'passport', 'vipiska'
      // this.refreshKey;

      /*
      if (this.dynamicFields.death) 
        required.push('deathproof')
      if (this.dynamicFields.invalid)
        required.push('invalidproof')
      */
      /*if (this.dynamicFields.FATCA)
        required.push('FATCA1','FATCA2','FATCA3')
      if (this.dynamicFields.adds.length)
        for (let el of this.dynamicFields.adds)
          required.push(el.name)
      for (let key of required)
        if (!this.form.files[key] || !this.form.files[key].length) return false
      if (this.forbiddenFileExts.length) {
        let set = new Set(this.fileExts.flat())
        for (let ext of this.forbiddenFileExts)
          if (set.has(ext))
            return false
      }*/
      return true
    },
  }
}
</script>

<style lang="sass">
.step
  width: 100%
  & &__delbutton
    margin-bottom: 0
    margin-left: auto
  &:not(&_active)
    max-height: calc(100vh - var(--headeroffset))
    overflow: hidden
  &__inner
    width: 604px
    max-width: 100%
    margin: 0 auto
  &__contract
    position: relative
    &-close
      flex-shrink: 0
      position: absolute
      top: 2px
      right: 2px
      z-index: 5
      width: 20px
      height: 20px
      cursor: pointer
      color: black
      svg
        width: 100%
        display: block

  &__title
    font-weight: 400
    font-size: 24px
    line-height: 1.16
    text-align: center
    margin-bottom: 38px
    color: colors.$gray3
    &_special
      position: relative
      padding-left: 30px
      padding-right: 30px
    &_left
      text-align: left
    &_smspace
      margin-bottom: 8px
    &_incspace
      margin-bottom: 64px
    &_topmg
      margin-top: 60px
  &__minititle
    font-size: 20px
    line-height: 1.18
    font-weight: 400
    color: colors.$gray3
    margin-bottom: 16px
  &__microtitle
    font-size: 16px
    font-weight: 400
    line-height: 1.28
    margin-bottom: 40px
  &__subtitle
    font-size: 14px
    line-height: 1.12
    color: colors.$newgray
    margin-bottom: 40px
    text-align: center
  &__text
    font-size: 16px
    line-height: 1.28
    color: colors.$gray5
    margin-bottom: 8px
  &__sm
    font-size: 14px
  &__line
    border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
    width: 100%
    margin: 40px 0 64px
    &_divider
      margin-bottom: 40px
  &__next
    width: 328px
    max-width: 100%
    margin: 32px auto
  @include for-mob
    &__title
      font-size: 22px
      line-height: 1.16
      margin-bottom: 32px
      &_smspace
        margin-bottom: 8px
      &_special
        font-size: 18px
        text-align: left
        padding-left: 0
        padding-right: 0
        display: flex
        align-items: center
    &__subtitle
      margin-bottom: 32px
    &__text
      line-height: 1.12
    &__minititle_spaced
      padding: 32px 0 16px
    &__minititle_spaced-bottom
      padding: 0 0 16px
    &__contract
      &-close
        margin-left: auto
        padding-left: 10px
        width: 30px
        position: static
        
</style>